import { FormField, getErrors, Switch } from '@maia/ui';
import { useFieldContext } from '../dynamic-form';
import { ComponentProps, useCallback, useMemo } from 'react';

type SwitchFieldProps = {
  options: [negativeValue: string, positiveValue: string];
} & Omit<ComponentProps<typeof FormField>, 'inputSlot'>;

export function SwitchField(props: SwitchFieldProps) {
  const { options, ...rest } = props;
  const field = useFieldContext<string>();

  const isActive = useMemo(
    () => field.state.value === options[1],
    [field.state.value, options],
  );

  const handleChange = useCallback(
    (value: boolean) => {
      field.handleChange(value ? options[1] : options[0]);
    },
    [field.handleChange, options],
  );

  return (
    <FormField
      {...rest}
      error={getErrors(field)}
      inputSlot={<Switch value={isActive} onChange={handleChange} />}
    />
  );
}
